module.exports = __webpack_public_path__ + "img/Camera.30525f94.svg";